import { ControlListProps, useTranslations } from "@bsm/component";
import _ from "lodash";

export const useUserStudentFamilyCreateEmailForm = (): ControlListProps => {
    const [
        SAVE,
        CANCEL,
        TO,
        EMAIL,
    ] = useTranslations(i18n);

    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "text",
                    name: "to",
                    label: TO,
                },
                {
                    type: "text",
                    name: "email",
                    label: EMAIL,
                    required: true,
                },
            ],
            next: {
                label: SAVE,
                className: "btn btn-primary text-white",
            },
            back: {
                label: CANCEL,
            },
        },
        id: 'user-student-family-create-email-form',
    };
}

const i18n = [
    "std_save",
    "std_cancel",
    "std_to",
    "std_email",
];